import React, { useState } from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import DateControlModal from './DateControlModal';

const BtnBox = styled.div`
  width: 100%;
  text-align: right;
  margin-bottom: 20px;

  & button {
    border: none;
    border-radius: .2rem;
    padding: 5px 20px;
    font-weight: bold;
    background-color: ${palette.webCyan[5]};
    color: #fff;
    font-size: 1rem;
    cursor: pointer;

    &:focus {
      outline: none;
    }
    
    &:hover {
      opacity: 0.9;
    }
  }
`;

const DateControl = ({
  dateControlForm,
  onSelect,
  onChangeTimeControlField,
  onDateControl,
  initControl,
  controlList,
  onUndoControlList,
  controlHistoryOpen,
  setControlHistoryOpen,
  dateControlLoading,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <BtnBox>
        <button onClick={() => setVisible(true)}>상품 기간 일괄 연장</button>
      </BtnBox>
      
      <DateControlModal
        dateControlForm={dateControlForm}
        visible={visible}
        setVisible={setVisible}
        onSelect={onSelect}
        onChangeTimeControlField={onChangeTimeControlField}
        onDateControl={onDateControl}
        resMembershipList={[]}
        resLockerList={[]}
        initControl={initControl}
        controlList={controlList}
        controlResult={null}
        onUndoControlList={onUndoControlList}
        controlHistoryOpen={controlHistoryOpen}
        setControlHistoryOpen={setControlHistoryOpen}
        dateControlLoading={dateControlLoading}
      />
    </>
  );
};

export default DateControl;

